module.exports = __webpack_public_path__ + "static/img/fayuan-icon6.e5dfd042.png";